import React from 'react';
import ShopReportForm from '../components/ShopReportForm'; // Passe den Pfad ggf. an
// import MainLayout from '../layouts/MainLayout'; // Entferne Import
import { Card, Col, Row } from 'antd'; // Optional: Für etwas Struktur

const ReportShopPage = () => {
    return (
        // <MainLayout> {/* Entferne Layout-Wrapper */} 
            <Row justify="center" style={{ marginTop: '20px', padding: '20px' }}>
                <Col xs={24} sm={20} md={16} lg={12} xl={10}>
                    <Card>
                        <ShopReportForm />
                    </Card>
                </Col>
            </Row>
        // </MainLayout> {/* Entferne Layout-Wrapper */}
    );
};

export default ReportShopPage; 